function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.5,
  stroke: "#495A95"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.2991 19.258C19.2298 19.258 18.36 18.3634 18.36 17.2638C18.36 16.1643 19.2298 15.2697 20.2991 15.2697C21.3685 15.2697 22.2387 16.1643 22.2387 17.2638C22.2387 18.3634 21.3685 19.258 20.2991 19.258ZM20.2991 13.748C18.3909 13.748 16.8383 15.3251 16.8383 17.2638C16.8383 19.2025 18.3909 20.7797 20.2991 20.7797C22.2076 20.7797 23.7605 19.2025 23.7605 17.2638C23.7605 15.3251 22.2076 13.748 20.2991 13.748ZM20.2983 27.853C19.7107 27.2008 18.7822 26.1138 17.8574 24.8023C15.8991 22.0251 14.8641 19.5354 14.8641 17.6021C14.8641 12.1595 19.0239 11.7364 20.2989 11.7364C25.3417 11.7364 25.7337 16.226 25.7337 17.6021C25.7337 21.4297 21.8396 26.139 20.2983 27.853ZM25.1791 11.723C23.9304 10.6104 22.1972 9.99731 20.2989 9.99731C18.4007 9.99731 16.6674 10.6104 15.4187 11.723C13.918 13.0604 13.125 15.0932 13.125 17.6021C13.125 23.0669 19.4139 29.4704 19.6815 29.7401C19.8448 29.9049 20.0672 29.9973 20.2989 29.9973C20.5307 29.9973 20.7531 29.9049 20.9163 29.7401C21.1839 29.4704 27.4728 23.0669 27.4728 17.6021C27.4728 15.0932 26.6798 13.0604 25.1791 11.723Z",
  fill: "#495A95"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14.3478,
  height: 20,
  fill: "white",
  transform: "translate(13.125 10)"
})));

var SvgIconLocation = function SvgIconLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_location.a95fa03c.svg";
export { ForwardRef as ReactComponent };